export default "/images/volume-x.svg?a190bf73596b92d5debd68b6176a54a4";